import { useCajaContext } from "@/features/cajas/caja-actual/contexts/caja-context";
import { Alert, Stack, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import { blue } from "@mui/material/colors";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";

const StyledAlert = styled(Alert)(({ theme }) => ({
    backgroundColor: blue[700],
    color: theme.palette.success.contrastText,
    paddingTop: 0,
    paddingBottom: 0
}))

export default function CajaLabel() {

    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const { cajaData } = useCajaContext();
    if (!cajaData) return <></>

    return <StyledAlert icon={false}>
        <Stack direction="row" alignItems="center" gap={0.5}>
            <PointOfSaleIcon sx={{ fontSize: { xs: 12, sm: 14 }, color: "inherit", opacity: 0.85 }} />
            <Typography variant="subtitle2" fontSize={{ xs: "0.6rem", sm: "0.8rem" }}>
                {`${cajaData.nombre}${cajaData.abierto && !smallScreen ? " - Abierto" : ""}`}
            </Typography>
        </Stack>
    </StyledAlert>
}